(function ($) {
	'use strict';
	window.w4d = window.w4d || {};

	w4d.instashop3 = {
		init: function () {
			var galleries = document.querySelectorAll('[id^="w4d-instashop-3-gallery-"]');
			if (!galleries.length) return;

			galleries.forEach(function (gallery) {
				lightGallery(gallery, {
					selector: '.instashop-3__item',
					plugins: [lgZoom, lgThumbnail],
					thumbnail: true,
					animateThumb: true,
					showThumbByDefault: false,
					exThumbImage: 'data-exthumbimage',
					speed: 500,
					download: false,
					showCloseIcon: true,
					mobileSettings: {
						showCloseIcon: true,
					},
				});
			});
		},
	};

	$(document).ready(function () {
		w4d.instashop3.init();
	});
})(jQuery);
